/**
 * A collection of helper functions for strings
 */
export module StringUtilities {



    export function ApiDateToDisplayedDate(apiDate: string) {
        if (apiDate == '' || apiDate == undefined) {
            return '';
        }

        var date = new Date(apiDate);
        if (!isValidDate(date)) {
            return '';
        }

        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [(dd > 9 ? '' : '0') + dd + "/",
        (mm > 9 ? '' : '0') + mm + "/",
        date.getFullYear(),
        ].join('');
    }

    export function isValidDate(dateInstance: Date) {
        return dateInstance instanceof Date;
    }

    export function removeSpaces(s: string): string {
        if (s == null) {
            return null;
        }

        return s.replace(/\s/g, '');
    }

    /**
     * Returns a boolean (true) if the string is empty.
     * @param str The string
     */
    export function isEmpty(str: string) {
        return str.length === 0;
    }

    /**
     * Returns a boolean (true) if the string is null or empty.
     * @param str The string
     */
    export function isEmptyOrNull(str: string) {
        return typeof str === 'undefined' || str === null || str.length === 0;
    }

    /**
     * Returns a boolean (true) if the string is null, empty or just whitespace.
     * @param str The string
     */
    export function isWhitespaceOrNull(str: string) {
        return typeof str === 'undefined' || str === null || str.trim().length === 0;
    }

    /**
     * Returns a boolean (true) if the base string contains the search term
     * @param baseString The string the search
     * @param searchTerm The search term
     * @param caseInsensitive Case Insensitive search?
     */
    export function contains(baseString: string, searchTerm: string, caseInsensitive: boolean = true) {
        if (caseInsensitive) {
            return baseString.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
        }

        return baseString.indexOf(searchTerm) !== -1;
    }

    export function capitaliseFirstChar(s: string) {
        if (typeof s !== 'string')
            return '';

        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    export function decapitaliseFirstChar(s: string) {
        if (typeof s !== 'string')
            return '';

        return s.charAt(0).toLowerCase() + s.slice(1);
    }

    export function toCamelCase(s: string) {
        if (typeof s !== 'string')
            return '';

        return s.charAt(0).toLowerCase() + s.slice(1);
    }

    // takes a string in the format "AStringLikeThis" and converts it to 
    // "A String Like This" by using capital letters as word boundaries
    export function convertToSentenceCase(input: string): string {
        const sb: string[] = [];

        for (let i = 0; i < input.length; i++) {
            const isFirstChar = i === 0;
            const isLastChar = i === input.length - 1;
            const charIsUpper = input[i] === input[i].toUpperCase();
            const nextCharIsUpper = !isLastChar && input[i + 1] === input[i + 1].toUpperCase();
            const prevCharWasLower = !isFirstChar && input[i - 1] === input[i - 1].toLowerCase();

            if (!isFirstChar && charIsUpper && sb[i - 1] !== ' ' && (!nextCharIsUpper || prevCharWasLower)) {
                sb.push(' ');
            }

            sb.push(input[i]);
        }

        return sb.join('');
    }

    export function coalesce(input: string | null, defaultValue: string): string {
        return input != null ? input : defaultValue;
    }
}